// src/components/Home.tsx
import React from 'react';
import styled from '@emotion/styled';
import { motion } from 'framer-motion';

const HomePageContainer = styled(motion.div)`
  padding-right: 40px;
  padding-left: 40px;
  text-align: center;
  color: #f0f0f0;

  h1 {
    font-size: 2em;
    margin-bottom: 20px;
    color: #fff;
    text-shadow: 0 0 10px rgba(0, 255, 255, 0.5);
  }

  p {
    text-align: left;
    font-size: 1.2em;
    line-height: 1.6;
    max-width: 800px;
    margin: 0 auto;
  }
`;

const Home: React.FC = () => {
  return (
    <HomePageContainer
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
    >
      <h1>LudyWorksへようこそ</h1>
      <p>
      「マーケティングとシステムで経営をより楽しく、より簡単に」<br />
        LudyWorksでは、マーケティングとシステム開発を通じて中小企業様や個人事業主様をサポートさせていただいております。<br />
        左のLudySphereから当社理念と当社概要についてご覧いただけます。<br />
        ぜひ一度ご覧くださいませ。
      </p>

    </HomePageContainer>
  );
};

export default Home;
